module.exports = __webpack_public_path__ + "img/checkout.e24fe456.svg";